export const birthLikeFactTypes = [
  'http://gedcomx.org/Birth',
  'http://gedcomx.org/Christening',
  'http://gedcomx.org/Baptism',
  'http://gedcomx.org/Blessing',
  'http://gedcomx.org/Circumcision',
]

export const marriageLikeFactTypes = [
  'http://gedcomx.org/Marriage',
  'http://gedcomx.org/Engagement',
  'http://gedcomx.org/MarriageBanns',
  'http://gedcomx.org/MarriageContract',
  'http://gedcomx.org/MarriageLicense',
  'http://gedcomx.org/MarriageNotice',
  'http://familysearch.org/types/facts/MarriageRegistration',
  'http://familysearch.org/types/facts/MarriageSettlement',
  'http://gedcomx.org/Divorce',
]

export const deathLikeFactTypes = [
  'http://gedcomx.org/Death',
  'http://gedcomx.org/Burial',
  'http://gedcomx.org/Cremation',
  'http://gedcomx.org/Funeral',
  'http://gedcomx.org/Obituary',
  'http://gedcomx.org/Probate',
  'http://gedcomx.org/Will',
]

export const sourceLinkerVitalFactTypes = [
  'http://gedcomx.org/Name',
  'http://gedcomx.org/Sex',
  'http://gedcomx.org/Birth',
  'http://gedcomx.org/Christening',
  'http://gedcomx.org/Death',
  'http://gedcomx.org/Burial',
]

export const treeAddableRelationshipFactTypes = [
  'http://gedcomx.org/Marriage',
  'http://gedcomx.org/CommonLawMarriage',
  'http://gedcomx.org/Divorce',
  'http://gedcomx.org/Annulment',
  'http://familysearch.org/v1/LivedTogether',
]

const vitalFactTypes = [...birthLikeFactTypes, ...marriageLikeFactTypes, ...deathLikeFactTypes]
export default vitalFactTypes
